import { delay } from "rxjs"

import type {
  IEquityInstrumentService,
  InstrumentRequest,
} from "@/generated/TradingGateway"

import { getMockEquityInstrumentResult } from "../mockData/equityInstrumentServiceData"

export const EquityInstrumentService: IEquityInstrumentService = {
  getInstruments: (input: InstrumentRequest) => {
    return getMockEquityInstrumentResult(input).pipe(delay(100))
  },
}
